import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import PortalGuard from './components/auth/PortalGuard';
import ComingSoonPage from './pages/ComingSoonPage';
import Dashboard from './components/dashboard/Dashboard';
import ApiKeys from './components/apikeys/ApiKeys';
import Usage from './components/usage/Usage';
import Credits from './components/credits/Credits';
import APIReference from './components/apireference/APIReference';
import Models from './components/models/Models';
import PrivacyRules from './components/admin/PrivacyRules';
import Navbar from './components/layout/Navbar';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router basename="/portal">
        <div className="min-h-screen bg-gray-50">
          <AppContent />
        </div>
      </Router>
    </AuthProvider>
  );
}

function AppContent() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/coming-soon" element={<ComingSoonPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  return (
    <PortalGuard>
      <Navbar />
      <main className="container mx-auto px-4 py-8">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/api-keys" element={<ApiKeys />} />
          <Route path="/usage" element={<Usage />} />
          <Route path="/credits" element={<Credits />} />
          <Route path="/api-reference" element={<APIReference />} />
          <Route path="/models" element={<Models />} />
          <Route path="/privacy-rules" element={<PrivacyRules />} />
          <Route path="/coming-soon" element={<ComingSoonPage />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </main>
    </PortalGuard>
  );
}

export default App;
